const ActivityFilters = () => {
  return (
    <div className="mt-6 flex flex-col justify-between gap-4 md:flex-row">
      <input
        type="text"
        placeholder="Search by action, user, or IP address..."
        className="w-full rounded-lg border px-4 py-2 shadow-sm focus:ring focus:ring-teal-200 md:w-1/2"
      />

      <div className="flex items-center gap-3">
        <select className="rounded-lg border px-3 py-2 text-sm">
          <option>All</option>
          <option>Success</option>
          <option>Info</option>
          <option>Warning</option>
          <option>Error</option>
        </select>

        <select className="rounded-lg border px-3 py-2 text-sm">
          <option>All Types</option>
          <option>Auth</option>
          <option>CMS</option>
          <option>Payment</option>
          <option>Security</option>
        </select>
      </div>
    </div>
  );
};

export default ActivityFilters;
